import { Controller } from '@hotwired/stimulus';

type TurboFrame = HTMLElement & { loaded: Promise<unknown> };

// Connects to data-controller="donation"
export default class extends Controller {
  static targets = ['fallbackValue'];
  fallbackValueTarget!: HTMLInputElement;

  get form(): HTMLFormElement {
    return this.element as HTMLFormElement;
  }

  async recalculate(): Promise<void> {
    const action = new URL(this.form.action, location.href);
    action.searchParams.set('recalculate', '1');
    this.form.action = action.toString();

    const turboFrame = this.form.closest('turbo-frame') as TurboFrame;
    turboFrame?.setAttribute('target', 'self');
    this.form.requestSubmit();
    turboFrame?.setAttribute('target', '_top');
  }

  uncheckRadioButton(event: MouseEvent): void {
    const radio = event.currentTarget as HTMLInputElement;
    this.fallbackValueTarget.disabled = false;
    radio.checked = false;

    this.recalculate();
  }
}
